export const state = {
    iconsTop: [
        {
            icon: "list.svg"
        },
        {
            icon: "envelope.svg"
        },
        {
            icon: "dollar.svg"
        }
    ],
    iconsBottom: [
        {
            icon: "gift.svg"
        },
        {
            icon: "bag.svg"
        },
        {
            icon: "box.svg"
        },
        {
            icon: "house.svg"
        }
    ],
    css: {
        top: "blue",
        middle: "middle_blue",
        bottom: "bottom_blue"
    }
};
